import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';

export interface TeamSeasonsExportRequest extends EntityExportRequest {
  /** whether only team seasons of active or only inactive competition seasons shall be exported, defaults to all team seasons */
  readonly active?: boolean;
  /** the id of the district of which to export the related team seasons, defaults to all team seasons */
  readonly districtId?: number;
  /** the id of the competition season of which to export the related team seasons, defaults to all team seasons */
  readonly competitionSeasonId?: number;
}

/**
 * This event can be fired to indicate that a service requires team seasons, optionally with a specific active flag.
 * Another service that is eligible to provide this info will put batches of the requested models into
 * the specified S3 {@see TeamSeasonsExportRequest.targetBucket} using
 * the {@see TeamSeasonsExportRequest.transactionId} as prefix (sub-folder).
 */
export class TeamSeasonsExportRequested extends DomainEvent<TeamSeasonsExportRequest> {}
